import Vue from 'vue';
import Router from 'vue-router';

import Students from './views/Students.vue';
import Assessments from './views/Assessments.vue';
import AssessmentViewer from './views/AssessmentViewer.vue';
import Classes from './views/Classes.vue';
import Settings from './views/Settings.vue';
import Help from './views/Help.vue';
import Assessment from '@/views/Assessment.vue';
import StudentDetail from '@/views/StudentDetail.vue';
import ClassDetail from '@/views/ClassDetail.vue';
import StudentAssessmentHistory from '@/views/StudentAssessmentHistory.vue';
import ClassHistory from '@/views/ClassHistory.vue';
import AssessmentSummary from '@/views/AssessmentSummary.vue';
import Reports from '@/views/Reports.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/students/:studentId+/tests/:testId+/do',
            name: 'do-test-for-student',
            component: Assessment,
        },
        {
            path: '/students',
            name: 'students',
            component: Students,
        },
        {
            path: '/students/:id+',
            name: 'student',
            component: StudentDetail,
        },
        {
            path: '/tests',
            name: 'tests',
            component: Assessments,
        },
        {
            path: '/tests/:id+',
            name: 'test',
            component: AssessmentViewer,
        },
        {
            path: '/reports/testhistory/:historyId+/summary',
            name: 'test-summary-for-student',
            component: AssessmentSummary,
        },
        {
            path: '/reports/testhistory/chart',
            name: 'test-history-chart',
            component: StudentAssessmentHistory,
        },
        {
            path: '/reports/classhistory/chart',
            name: 'class-history-chart',
            component: ClassHistory,
        },
        {
            path: '/reports',
            name: 'reports',
            component: Reports,
        },
        {
            path: '/classes',
            name: 'classes',
            component: Classes,
        },
        {
            path: '/classes/:id+',
            name: 'class',
            component: ClassDetail,
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings,
        },
        {
            path: '/help',
            name: 'help',
            component: Help,
        },
        {
            path: '*',
            name: 'allOthers',
            redirect: '/tests',
        },
    ],
});
